<template>
    <!-- modal-xl -->
    <b-modal id="certificateListModal" size="xl" title="Certificate List" title-class="font-18" hide-footer @hide="onHide">
        <div>
            <b-row class="ml-2 mb-1">
                <h3>Suppliers:</h3>
                <h3 class="ml-2 font-weight-light">{{ selected_supplier_details.supplier_name }}</h3>
            </b-row>
            <b-row class="ml-2 mb-1">
                <h5 class="">Vat no:</h5>
                <h5 class="ml-2 font-weight-light">{{ selected_supplier_details.vat_no }}</h5>
                <h5 class="ml-5">Reg no:</h5>
                <h5 class="ml-2 font-weight-light">{{ selected_supplier_details.company_reg }}</h5>
            </b-row>
            <hr />
            <div v-if="hasMounted">
                <div v-if="suppliers_loading_status == true" class="text-center">
                    <!-- <b-spinner variant="primary" label="Spinning"></b-spinner> -->
                    <!-- <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner> -->
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                </div>
                <div v-else-if="supplier_certificates_data.length > 0">
                    <b-overlay :show="show">
                        <!-- <div v-show="supplier_certificates.length > 0"> -->
                        <webix-ui :config="ui" v-model="supplier_certificates_data"></webix-ui>
                        <div id="certificateListModalPaging"></div>
                    </b-overlay>
                    <!-- </div> -->
                    <!-- <div v-show="supplier_certificates.length == 0">No certificates</div> -->
                </div>
                <div v-else-if="suppliers_loading_status == false" class="ml-2">
                    This supplier has no certificates.
                </div>
                <div v-else>Something went wrong...</div>
            </div>
        </div>

        <div v-if="findPermission('Add and Edit Certificates') || isTypeUser" class="modal-footer mt-3 d-flex justify-content-between">
            <button type="button" class="btn btn-primary" @click="handleModal('certificateAddSearchModal')">
                Add New Certificate
            </button>
            <button type="button" class="btn btn-primary" @click="closeModal">
                Close
            </button>
        </div>
        <div v-else class="modal-footer mt-3 d-flex">
            <button type="button" class="btn btn-primary" @click="closeModal">
                Close
            </button>
        </div>

        <!-- Modals -->
    </b-modal>
</template>

<script>
import { adminComputed, adminMethods, suppliersComputed, suppliersMethods } from "@/state/helpers";
import { cloneDeep } from "lodash";
//eslint-disable-next-line
import Swal from "sweetalert2";

export default {
    components: {},
    data: () => ({
        hasPermissionToDelte: false,
        resize_event: null,
        hasMounted: false,
        show: false,
    }),
    computed: {
        ...adminComputed,
        ...suppliersComputed,
        supplier_certificates_data() {
            return cloneDeep(this.supplier_certificates);
        },
        ui() {
            let el = this;
            let ui = {
                id: "certificateListModalTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border",
                autoheight: true,
                //hover: "datatableHover",
                hover: "certificateListeHoverRow",
                minHeight: 35,
                minColumnWidth: 120,
                rowHeight: 45,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                select: false,
                // pager: {
                //     template: "{common.prev()} {common.pages()} {common.next()}",
                //     container: "certificateListModalPaging",
                //     css: { width: "100% !important" },
                //     size: 15,
                //     group: 5,
                // },
                columns: [
                    {
                        id: "active",
                        checkValue: "1",
                        uncheckValue: "0",
                        // header: [{ content: "masterCheckbox" }],
                        header: { text: "Active", css: { "text-align": "center" } },
                        // template: "{common.radio()}",
                        css: { "text-align": "center" },
                        maxWidth: 85,
                        sort: "int",
                        template: function(obj) {
                            if (obj.active == 1) {
                                return `<div class="on_radio_click change-to-pointer"><i class="bx bx bx-radio-circle-marked bx-sm non-active_switch table-top-margin"></i> </div>`;
                            }
                            if (obj.active == 0) {
                                return `<div class="on_radio_click change-to-pointer"><i class="bx bx bx bx-radio-circle bx-sm non-active_switch table-top-margin"></i> </div>`;
                            }
                        },
                    },
                    {
                        id: "actions",
                        header: [{ text: "Actions", css: { "text-align": "center" } }],
                        fillspace: 0.5,
                        template: function() {
                            let permissionConcat = "";

                            el.findPermission("Add and Edit Certificates") || el.isTypeUser
                                ? (permissionConcat += ` <i v-b-tooltip.hover title="Edit" class="bx bx-edit editAction } "></i>`)
                                : "";

                            permissionConcat += ` <i v-b-tooltip.hover title="View" class="bx bx-file viewAction"></i>`;

                            el.findPermission("Delete Certificates") || el.isTypeUser
                                ? (permissionConcat += ` <i v-b-tooltip.hover title="Delete" class="bx bx-trash deleteAction "></i>`)
                                : "";

                            return ` <div class="tableIcons">
                                ${permissionConcat}
                            </div>;`;
                        },
                    },
                    {
                        id: "company_name",
                        // header: ["Name", { content: "textFilter" }],
                        header: "Name",
                        tooltip: false,
                        width: 200,
                    },
                    {
                        id: "document_type",
                        // header: ["Document Type", { content: "selectFilter" }],
                        header: "Document Type",
                        tooltip: false,
                        sort: "string",
                    },
                    {
                        id: "issue_date",
                        // header: ["Issue Date", { content: "textFilter" }],
                        header: "Issue Date",
                        fillspace: 0.8,
                        template: function(obj) {
                            // let newDate = obj.issue_date.substring(0, 10);
                            return obj.issue_date.substring(0, 10);
                        },
                        sort: "string",
                    },
                    {
                        id: "expiry_date",
                        // header: ["Expiry Date", { content: "textFilter" }],
                        header: "Expiry Date",
                        fillspace: 0.8,
                        template: function(obj) {
                            // let newDate = obj.issue_date.substring(0, 10);
                            return obj.expiry_date.substring(0, 10);
                        },
                        sort: "string",
                    },
                    {
                        id: "vetting_status",
                        // header: ["Vetting Status", { content: "textFilter" }],
                        header: "Vetting Status",
                        fillspace: 0.8,
                        sort: "string",
                        template: function(obj) {
                            if (obj.document_type == "Certificate") {
                                //eslint-disable-next-line
                                if (obj.authentication_status == null) {
                                    return "Not Authenticated";
                                }
                                return obj.authentication_status;
                            }

                            if (obj.document_type == "Affidavit") {
                                //eslint-disable-next-line
                                if (obj.vetting_status == null) {
                                    return "Not Vetted";
                                }
                                return obj.vetting_status;
                            }

                            return obj.vetting_status;
                        },
                    },
                    {
                        id: "bbbee_level",
                        // header: ["Bee Level", { content: "selectFilter" }],
                        header: "BEE Level",
                        tooltip: false,
                        adjust: true,
                        sort: "int",
                    },
                ],
                ready() {
                    // this.markSorting("active", "desc");

                    el.resize_event = window.webix.event(window, "resize", function() {
                        el.$nextTick(() => {
                            window.webix.$$(el.ui.id).refresh();
                        });
                    });
                },
                onClick: {
                    //eslint-disable-next-line
                    on_radio_click: function(event, id) {
                        //eslint-disable-next-line
                        let item = this.getItem(id);

                        //eslint-disable-next-line
                        let el = this.$scope.$parent.$parent.$parent.$parent;

                        el.handleSwal(item);
                    },
                    //eslint-disable-next-line
                    deleteAction(id, e, trg) {
                        //eslint-disable-next-line
                        let item = this.getItem(e.row);
                        //eslint-disable-next-line
                        let el = this.$scope.$parent.$parent.$parent.$parent;

                        el.handleSwalDelete(item);
                    },
                    //eslint-disable-next-line
                    viewAction: function(id, e, trg) {
                        // alert("help");

                        //eslint-disable-next-line
                        let item = this.getItem(e.row);
                        //eslint-disable-next-line
                        let el = this.$scope.$parent.$parent.$parent.$parent;

                        //TODO: need to save the data from the row to the vuex store

                        // el.$emit("handleModal", "certificateEditModal");
                        // el.$emit("certificateAddSearchModal");

                        el.setSelectedCertificate(item);

                        el.$emit("handleModal", "certificateViewModal");

                        el.closeModal();

                        // el.certificateEditModal();
                    },
                    //eslint-disable-next-line
                    editAction: function(id, e, trg) {
                        //eslint-disable-next-line
                        let item = this.getItem(e.row);

                        //eslint-disable-next-line
                        let el = this.$scope.$parent.$parent.$parent.$parent;

                        el.setSelectedCertificate(item);

                        el.$emit("handleModal", "certificateEditModal");

                        el.closeModal();
                    },
                },
            };

            //pager
            if (this.supplier_certificates_data.length >= 7) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "certificateListModalPaging",
                    css: { width: "100% !important" },
                    size: 7,
                    group: 5,
                };
            }

            return ui;
        },
    },
    watch: {
        supplier_certificates() {
            setTimeout(() => {
                window.webix.$$("certificateListModalTable").refresh();
            }, 75);
        },
    },
    methods: {
        ...adminMethods,
        ...suppliersMethods,
        onHide(evt) {
            if (evt.trigger === "backdrop") {
                evt.preventDefault();
                this.handleBackdrop();
            }
        },
        handleBackdrop() {
            //eslint-disable-next-line
            console.log("Backdrop clicked");
        },
        closeModal() {
            this.$bvModal.hide("certificateListModal");
        },
        handleModal(modelName) {
            this.closeModal();

            this.$emit("handleModal", modelName);
        },
        handleSwal(item) {
            let client_supplier_id = this.selected_supplier_details.id;

            let table = window.webix.$$("certificateListModalTable");
            this.show = true;
            if (item.active == 0) {
                Swal.fire({
                    title: ` Set Certifcate as Active `,
                    text: `Are you sure you would like to set this certificate as active`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Confirm",
                }).then((result) => {
                    if (result.value) {
                        item.active = 1;

                        this.updateActiveClientSupplierCertificate({
                            certificate_id: item.certificate_id,
                            client_supplier_id: client_supplier_id,
                            active: 1,
                        }).then(() => {
                            Swal.fire(`Certificate was set as active`, "", "success");

                            table.updateItem(item.id, item);
                            table.refresh();
                            //refresh
                            this.setSupplierCertificates(this.selected_supplier_details.id);
                            this.show = false;
                        });
                    }
                    this.show = false;
                });
            } else {
                this.show = false;
            }
        },
        //eslint-disable-next-line
        handleSwalDelete(item) {
            let client_supplier_id = this.selected_supplier_details.id;

            Swal.fire({
                title: ` Delete the certificate `,
                text: `This cannot be undone`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.deleteClientSupplierCertificate({ certificate_id: item.certificate_id, client_supplier_id: client_supplier_id }).then(() => {
                        Swal.fire(`Certificate was deleted`, "", "success");

                        this.setSupplierCertificates(this.selected_supplier_details.id);
                    });
                }
            });
        },
    },
    mounted() {
        this.hasMounted = true;

        window.certificatesTable = this;

        // this.setSupplierCertificates(this.selected_supplier_details.id);
        if (this.findPermission("Delete Certificates") || this.isTypeUser) {
            this.hasPermissionToDelte = true;
        }
    },
};
</script>

<style>
.change-to-pointer {
    cursor: pointer;
}
.table-top-margin {
    margin-top: 11px;
}
.handle-overflow {
    overflow: scroll;
}
.certificateListeHoverRow {
    background: #f0dcb6;
    cursor: default;
}
.hide-function {
    display: none;
}
</style>
